import React from 'react';

export const CheckIcon = ({ color = '#4EBD25', ...restProps }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      {...restProps}
    >
      <path
        d="M30 9L13.5 25.5L6 18"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
